import '@fontsource-variable/public-sans';

import type { CSSProperties } from 'react';

export function ShutdownPage() {
  return (
    <main style={styles.page}>
      <div style={styles.content}>
        <p className="shutdown-fade-out" style={styles.fadeOut}>
          And then song assist was fading out....
        </p>
        <p style={styles.thanks}>Thanks for all support and feedback</p>
        <p style={styles.unplugging}>We&apos;re officially unplugging</p>
      </div>

      <style>{`
        @keyframes fadeOut {
          0% {
            opacity: 1;
          }
          100% {
            opacity: 0.35;
          }
        }

        .shutdown-fade-out {
          animation: fadeOut 4s ease-in-out infinite alternate;
        }
      `}</style>
    </main>
  );
}

const styles: Record<string, CSSProperties> = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#ffffff',
    padding: '24px',
    fontFamily: '"Public Sans Variable", "Public Sans", sans-serif',
    color: '#141a21',
  },
  content: {
    maxWidth: '640px',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  },
  fadeOut: {
    margin: 0,
    fontSize: 'clamp(1.25rem, 3vw, 1.75rem)',
    fontWeight: 500,
    lineHeight: 1.5,
    letterSpacing: '-0.01em',
  },
  thanks: {
    margin: 0,
    fontSize: 'clamp(1rem, 2.5vw, 1.25rem)',
    fontWeight: 400,
    lineHeight: 1.6,
    color: '#637381',
  },
  unplugging: {
    margin: 0,
    fontSize: 'clamp(1.125rem, 2.75vw, 1.5rem)',
    fontWeight: 600,
    lineHeight: 1.5,
    letterSpacing: '-0.01em',
  },
};
